import * as jQuery from 'jquery';
import 'bootstrap/dist/js/bootstrap';
import {BloomChat} from "./BloomChat";
import {BloomRegister} from "./BloomRegister";
import {WPAjaxObject} from "./WPAjaxObject";

export class BloomForWomen
{
    private jQuery:JQuery;
    private bloomChat:BloomChat;
    private register:BloomRegister;

    constructor(private wpAjaxObj:WPAjaxObject, private window:Window) {
        this.register = new BloomRegister(this.wpAjaxObj, this.jQuery);
    }

    public init() {
        jQuery(document).ready(() => {
            this.initAutoAssignMember();
            this.initCoachMemberEdit();
            this.initRegistration();
            this.initAddCoachSubscription();
            this.initRemoveCoachSubscription();
        });
    }

    public initRegistration() {
        this.register.init();
    }

    public createChat(publishKey:string, subscribeKey:string) : BloomChat {
        let chat = new BloomChat(publishKey, subscribeKey, this.wpAjaxObj, this.window);
        return chat;
    }
    public initAutoAssignMember() {
        jQuery(".bloom-auto-assign-member").each((index, element) => {
            var member_id = +jQuery(element).data('member-id');
            jQuery(element).click(() => {
                return this.autoAssignMemberToCoach(member_id, element);
            });
        });
    }
    public initCoachMemberEdit() {
        jQuery(".modal .coach-member-edit-btn").click((event) => {
            var modal = jQuery(event.target).closest(".modal");
            
            jQuery.post(this.wpAjaxObj.ajax_url, {
                    action: 'bloom_coach_update_member'
                    ,member_id: modal.find(".member-id").val()
                    ,phone: modal.find(".phone-input").val()
                    ,timezone: modal.find(".timezone-input").val()
                }, null, 'json')
            .done((resp) => {
                modal.modal("hide");
                window.location.reload(); // reload everything so we get the latest data.. bit cheap but it works.
            })
            .fail((error) => {
                alert("There was an error saving the member data.  Please try again, or contact customer support");
                console.error(error);
            })
            .always(() => {
            });
        });
    }

    public autoAssignMemberToCoach(memberId:number, updateElement:HTMLElement) {
        jQuery(updateElement).hide();
        var progress = jQuery(updateElement).after("<p id='auto-assign-member-" + memberId + "'>Processing...</p>");
        jQuery.post(this.wpAjaxObj.ajax_url, {
            action: 'bloom_auto_assign_member'
            ,member_id: memberId
        }, null, 'json').done((resp) => {
            if (0 == resp) {
                console.error("Server responded with no access error");
                alert("Failed to auto assign member to a coach.  Permission denied");
                return;
            }
            jQuery(updateElement).replaceWith(resp.assignmentText);
        })
        .fail((error) => {
            console.error(error);
            alert("Failed to auto assign member to a coach.  Check that the coaches aren't full and your internet connection is working");
        })
        .always(() => {
            jQuery("#auto-assign-member-" + memberId).remove();
            jQuery(updateElement).show();
        });
    }

    /**
     * Handles the adding of subscriptions onto the coach's 
     */
    public initAddCoachSubscription() {
        jQuery(".bloom-coach-profile-subscription .button-add-subscription").click((evt:any) => {
            let subscriptionId = +(jQuery("#coach-group-subscription-add").val());
            let userId =  +(jQuery("#your-profile #user_id").val());
            if (isNaN(subscriptionId) || subscriptionId <= 0) {
                alert("You selected an invalid subscription");
                console.error("Subscription id was NaN");
                return;
            }
            if (isNaN(userId)) {
                console.log("Invalid user id");
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();
            jQuery.post(this.wpAjaxObj.ajax_url, {
                action: 'bloom_coach_add_subscription'
                ,subscription_id: subscriptionId
                ,member_id: userId
            }, null, 'json').done((resp) => {
                if (0 == resp) {
                    console.error("Server responded with no access error");
                    alert("Failed to update coach subscription.  Permission denied");
                    return;
                }
                else {
                    window.location.reload(); // reload the page, to show the latest data.
                }
            })
            .fail((error) => {
                console.error(error);
                alert("Failed to update coach subscription.  Check that your internet connection is working");
            })
        });
    }

    /**
     * Handles the removing of coach subscriptions on the coach's user profile page.
     */
    public initRemoveCoachSubscription() {
        jQuery(".bloom-coach-profile-subscription .button-delete-subscription").click((evt:any) => {
            let button = event.target;
            let subscriptionId = +(jQuery(button).data('subscription-id'));
            let userId =  +(jQuery("#your-profile #user_id").val());
            if (isNaN(subscriptionId) || subscriptionId <= 0) {
                alert("An error occurred in deleting this subscription");
                console.error("Subscription id was NaN and should have been set in delete button");
                return;
            }

            if (isNaN(userId)) {
                console.log("Invalid user id");
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();
            jQuery.post(this.wpAjaxObj.ajax_url, {
                action: 'bloom_coach_remove_subscription'
                ,subscription_id: subscriptionId
                ,member_id: userId
            }, null, 'json').done((resp) => {
                if (0 == resp) {
                    console.error("Server responded with no access error");
                    alert("Failed to remove coach subscription.  Permission denied");
                    return;
                }
                else {
                    window.location.reload(); // reload the page, to show the latest data.
                }
            })
            .fail((error) => {
                console.error(error);
                alert("Failed to remove coach subscription.  Check that your internet connection is working");
            })
        });
    }
}